import axios from "axios";
import dayjs from "dayjs";
import moment from "moment";
import { BASE_URL } from "../config/api_collection";
import { MOCK_DATA_MODE } from "../constants/config/config";
import { ERROR_API_NAME } from "../constants/variables";
import apolloClient from "../graphql";
import { GET_LOWFARE_ESTIMATE } from "../graphql/queries";
import { getToken } from "../helper/token";
import { errorHandingErrorMessage } from "../services/errrorHandling/errorHandling";

const CALENDAR_LOW_FARE_MONTHLY_DETAILS = `${BASE_URL}/api/ibe/availability`;

// function to fetch all the low fares to display in the pricing calender.
export async function fecthData(origin: string, destination: string, presentDate: Date, selectedCurrency: string) {
  if (MOCK_DATA_MODE) {
    return {};
  }
  try {
    const currentDate = moment(presentDate);
    const futureMonth = moment(currentDate).add(60, "d");
    const response = await apolloClient.query({
      query: GET_LOWFARE_ESTIMATE,
      variables: {
        request: {
          currencyCode: selectedCurrency,
          origin,
          destination,
          startDate: currentDate.format("YYYY-MM-DD"),
          endDate: futureMonth.format("YYYY-MM-DD"),
          includeTaxesAndFees: true,
          numberOfPassengers: 1
        }
      }
    });
    return response;
  } catch (error) {
    return errorHandingErrorMessage(ERROR_API_NAME.LOW_FARE_CALENDER, error);
  }
}

export async function getLowFareForMonth(
  origin: string,
  destination: string,
  presentDate: Date | string,
  selectedCurrency: string
) {
  try {
    const currentDate = dayjs(presentDate);
    const headers = await getToken();
    const apiUrl = `${CALENDAR_LOW_FARE_MONTHLY_DETAILS}`;
    const params: URLSearchParams = new URLSearchParams({
      origin,
      destination,
      startDate: currentDate.format(),
      numberOfPassengers: "1",
      channel: "WEB",
      currencyCode: selectedCurrency
    });

    const url = `${apiUrl}?${params.toString()}`;
    const response = await axios.get(url, { headers });
    return response;
  } catch (error) {
    return errorHandingErrorMessage(ERROR_API_NAME.LOW_FARE_CALENDER, error);
  }
}
